module.exports = __webpack_public_path__ + "static/1421-9cf8652db1c0208a2abdb9fbc370d6dd.jpg";